import React from 'react';
import { useSelector } from 'react-redux';
import {
  deferTracking,
  sendGAEvent,
  sendGALinkClickEvent,
} from '@noths/polaris-client-google-analytics';
import type { CopyBlockAlignment } from '@noths/polaris-client-ribbons-design-system';
import { CopyBlock } from '@noths/polaris-client-ribbons-design-system';
import parse from 'html-react-parser';

import { selectCopyBlockContent } from 'src/redux/content/selectors/selectCopyBlockContent';

export const CopyBlockContainer = () => {
  const copyBlock = useSelector(selectCopyBlockContent);
  const trackingTitle = copyBlock?.trackingTitle || '';

  const trackImpression = () => {
    // Defer off the critical path: impressions are fire-and-forget and do not gate navigation.
    deferTracking(() =>
      sendGAEvent({
        event: 'custom_event',
        event_action: 'Impression',
        event_category: 'Copy block',
        event_label: trackingTitle.toLowerCase(),
        event_name: 'view_content',
        content_type: `copy block|${trackingTitle}`.toLowerCase(),
      }),
    );
  };

  const trackLinkClick = (e: React.MouseEvent) => {
    const { href, textContent } = e.target as HTMLAnchorElement;

    sendGALinkClickEvent(e, {
      event: 'custom_event',
      event_action: 'Link click',
      event_category: 'Copy block',
      event_label: `${trackingTitle} | ${textContent}`.toLowerCase(),
      event_name: 'select_content',
      event_details: 'link click',
      content_type: `copy block|${trackingTitle}`,
      destination_URL: href,
      item_id: (textContent || '').toLowerCase(),
    });
  };

  if (copyBlock) {
    return (
      <CopyBlock
        alignment={copyBlock.alignment as CopyBlockAlignment}
        onLinkClick={trackLinkClick}
        onVisible={trackImpression}
      >
        {parse(copyBlock.copy)}
      </CopyBlock>
    );
  }

  return null;
};
